var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "project-contractor-info",
      attrs: { id: "projectContractorInfo" },
    },
    [
      (_vm.updatorName && _vm.updatedTime) || _vm.canEdit
        ? _c("div", { staticClass: "contractor-info-head clearfix" }, [
            _vm.updatorName && _vm.updatedTime
              ? _c("div", { staticClass: "updator-info" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("lastUpdatedBy", [
                          _vm.updatorName,
                          _vm.updatedTime,
                        ])
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.canEdit
              ? _c(
                  "div",
                  { staticClass: "contractor-info-buttons" },
                  [
                    !_vm.isEditing
                      ? _c("HKLButton", {
                          staticClass: "no-min-width",
                          attrs: { action: "edit", color: "darkblue" },
                          on: { click: _vm.enableEdit },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c("HKLButton", {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "no-min-width",
                          attrs: { action: "cancel", color: "darkblue" },
                          on: { click: _vm.cancel },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c("HKLButton", {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "no-min-width",
                          attrs: { action: "save", color: "orange" },
                          on: { click: _vm.doSave },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "contractor-instruction",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t(
              "termsAndConditions." +
                _vm.regionName +
                ".tenancy.contractorInfoRemark"
            )
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-contractor-card" },
        [
          _c("ContractorFields", {
            attrs: {
              contractor: _vm.currentMainContractor,
              inputRequireHighlight: _vm.inputRequireHighlight,
              isEditing: _vm.isEditing,
              canEdit: _vm.canEditMainCon,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.currentContractors || [], function (contractor, index) {
        return _c(
          "div",
          { key: index, staticClass: "sub-contractor-card" },
          [
            _c("ContractorFields", {
              attrs: {
                contractor: contractor,
                canEdit: _vm.canEdit,
                inputRequireHighlight: _vm.inputRequireHighlight,
                isEditing: _vm.isEditing,
                contractorIndex: index,
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.isEditing && _vm.canEdit
        ? _c("div", { staticClass: "add-contractor-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "btn add-contractor-btn",
                attrs: { type: "button" },
                on: { click: _vm.addContractor },
              },
              [_vm._v(_vm._s(_vm.$t("contact.addSubContractor")))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ContractorsInviteModalVue", {
        ref: "contractorsInviteModal",
        attrs: { canInvite: _vm.canEdit },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }